import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MemberSetPasswordInput, MemberSetPasswordPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = MemberSetPasswordInput;
type TData = MemberSetPasswordPayload;

export const useMemberPassword = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation memberSetPassword($input: MemberSetPasswordInput!) {
      memberSetPassword(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
